export const buildInitialValues = (unit) => ({
  id: (unit && unit.id) || "",
  block: (unit && unit.block) || null,
  client: (unit && unit.client) || null,
  contract: (unit && unit.contract) || null,
  settlement_price: (unit && unit.settlement_price) || null,
  unit_type: (unit && unit.unit_type) || "",
  nr: (unit && unit.nr) || "",
  initial_price: (unit && unit.initial_price) || "",
  settled_price: (unit && unit.settled_price) || null,
  cf: (unit && unit.cf) || "",
  floor: (unit && unit.floor) || "",
  num_rooms: (unit && unit.num_rooms) || "",
  net_sqm: (unit && unit.net_sqm) || "",
  gross_sqm: (unit && unit.gross_sqm) || "",
  apt_net_sqm: (unit && unit.apt_net_sqm) || "",
  terrace_net_sqm: (unit && unit.terrace_net_sqm) || "",
  apt_type: (unit && unit.apt_type) || "",
  created_at: (unit && unit.created_at) || "",
});
